import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Formik, Form, Field } from "formik";
import { FormLayout } from "../../components/form-layout/form-layout.js";
import { SubmitButton } from "../../components/submit-button/submit-button.js";
import { validationSchema } from "../../utils/fields/miscellaneous.js";
import { getFormInitialErrors } from "../../utils/helpers/getFormInitialErrors.js";
import { combinedFields } from "../../utils/yup/main.js";
import "react";
import "react-dom";
import "@mui/material";
import "lodash";
import "../../utils/helpers/createField.js";
import "../../components/address-field/address-field.js";
import "../../utils/helpers/getHasError.js";
import "../../utils/hooks/useAddressSuggestions.js";
import "use-debounce";
import "../../utils/helpers/googlePlaces.js";
import "../../utils/helpers/places.js";
import "../../utils/hooks/useFormHelpers.js";
import "../../utils/hooks/useSubmitCount.js";
import "../../utils/shared/TextField.js";
import "../../utils/shared/TextFieldLabel.js";
import "../../components/field-helper-text/field-helper-text.js";
import "../../components/translate/translate.js";
import "yup";
import "../../utils/fields/personalInformation.js";
import "../../../../../type/Appointment.js";
import "../../components/masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../utils/entities/Form.js";
import "../../../ana-toolbox/ana-toolbox.js";
import "../../../../../constants/date/date.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "date-fns";
import "../../utils/helpers/toBoolean.js";
import "../../utils/helpers/createFields.js";
import "../../utils/helpers/resetFields.js";
import "../../utils/yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../utils/helpers/predicates.js";
import "../../utils/yup/emailValidation.js";
import "../../utils/fields/contactDetails.js";
import "../../utils/helpers/featureFlags.js";
import "../../utils/helpers/getAgeFromBirthday.js";
import "../../utils/yup/buildValidationSchema.js";
import "../../utils/fields/insurance.js";
import "../../utils/fields/allergiesAndMedications.js";
import "../../../../../type/Disease.js";
import "../../utils/config/medicaments.js";
import "../../utils/fields/wishesAndExpectations.js";
import "../../utils/fields/consents.js";
import "../../utils/fields/profileInterest.js";
import "../../components/checkbox-field/checkbox-field.js";
import "../../utils/shared/Checkbox.js";
import "../../components/checkbox-field/checkbox-field.styles.js";
import "../../utils/shared/FormControlLabel.js";
import "../../components/date-picker-field/date-picker-field.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "date-fns/fp/formatWithOptions";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "../../utils/helpers/date.js";
import "date-fns/fp/startOfMonth";
import "date-fns/fp/subYears";
import "../../components/date-picker-field/date-picker-field.styles.js";
import "@mui/x-date-pickers";
import "../../components/phone-field/phone-field.js";
import "react-window";
import "@mui/icons-material/ArrowDropDown.js";
import "@mui/icons-material/Close.js";
import "libphonenumber-js";
import "../../utils/helpers/phoneMetadata.js";
import "../../components/text-input/text-input.js";
import "../../components/text-input/text-input.styles.js";
import "../../components/phone-field/phone-field.styles.js";
import "@emotion/react";
import "../../components/radio-group/radio-group.js";
import "use-deep-compare";
import "../../utils/shared/Radio.js";
import "../../utils/shared/RadioFormControl.js";
import "../../utils/shared/RadioFormControlLabel.js";
import "../../utils/shared/RadioFormLabel.js";
import "../../utils/shared/RadioGroup.js";
import "../../components/select-field/select-field.js";
import "../../components/select-input/select-input.js";
import "../../components/select-input/select-input.styles.js";
import "../../components/text-field/text-field.js";
import "../../components/toggle-field/toggle-field.js";
import "../../utils/shared/ToggleContainer.js";
import "../../utils/shared/ToggleFormControlLabel.js";
import "../../utils/helpers/getIsRequired.js";
import "../../utils/hooks/useFormValue.js";
import "../../components/form-layout/form-layout.styles.js";
import "../../../../../components/loader/loader.js";
import "../../../../../components/loader/data.js";
import "../../../../../components/animation/animation.js";
import "lottie-react";
import "../../../../../components/loader/loader.styles.js";
import "../../utils/shared/Button.js";
import "../../components/submit-button/submit-button.styles.js";
import "@mui/system";
const miscellaneousLayout = [
  { type: "field", field: combinedFields.occupation, xs: 12 },
  { type: "field", field: combinedFields.isPregnant, xs: 12 },
  { type: "field", field: combinedFields.pregnantMonths, xs: 12 },
  { type: "field", field: combinedFields.isSmoker, xs: 12 },
  {
    type: "field",
    field: combinedFields.cigarretesPerDay,
    xs: 12
  },
  {
    type: "field",
    field: combinedFields.consumesAlcohol,
    xs: 12
  },
  { type: "field", field: combinedFields.consumesDrugs, xs: 12 },
  {
    type: "field",
    field: combinedFields.weightOver120Kg,
    xs: 12
  },
  { type: "field", field: combinedFields.heightOver2M, xs: 12 }
];
const MiscellaneousForm = ({ initialValues, portalAttr, onSubmit, loading, innerRef }) => {
  const { t } = useTranslation();
  const submitButton = /* @__PURE__ */ jsx(Field, { children: (props) => /* @__PURE__ */ jsx(SubmitButton, { loading, onClick: () => props.form.submitForm(), disabled: !props.form.isValid, children: t("next") }) });
  return /* @__PURE__ */ jsx(
    Formik,
    {
      innerRef,
      initialValues,
      initialErrors: getFormInitialErrors(validationSchema, initialValues),
      validationSchema,
      onSubmit,
      children: /* @__PURE__ */ jsx(Form, { children: /* @__PURE__ */ jsx(FormLayout, { portalAttr, items: miscellaneousLayout, submitButton }) })
    }
  );
};
export {
  MiscellaneousForm
};
